export default __webpack_public_path__ + "static/1678-680188ade120500e8dd68b7ee6ff4c9c.gif";